import { useCallback, useEffect, useRef } from 'react';

export const useTimeout = () => {
  const timeoutRefs = useRef<NodeJS.Timeout[]>([]);

  const setSweepTimeout = useCallback((callback: (value: unknown) => void, delay?: number) => {
    const timeout = setTimeout(callback, delay ?? 0);
    timeoutRefs.current.push(timeout);
    return timeout;
  }, []);

  useEffect(() => {
    return () => {
      timeoutRefs.current.forEach((timeout) => clearTimeout(timeout));
      timeoutRefs.current = [];
    };
  }, []);

  return { setSweepTimeout };
};
